export default "\n<cx-storefront>Loading...</cx-storefront>\n\n"